import DonutChart from './DonutChart.vue';

export default DonutChart;
